import { render, staticRenderFns } from "./list.vue?vue&type=template&id=89c863c0&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=89c863c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c863c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89c863c0')) {
      api.createRecord('89c863c0', component.options)
    } else {
      api.reload('89c863c0', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=89c863c0&scoped=true&", function () {
      api.rerender('89c863c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inbox/list.vue"
export default component.exports